import { IconCheckmarkCircled, IconCircle } from '@wheely/ui-kit';
import cn from 'classnames';
import { ReactNode } from 'react';

import s from './styles.module.css';

const CheckPoint = ({
  children,
  isChecked = false,
}: {
  children: ReactNode;
  isChecked?: boolean;
}) => {
  const Component = isChecked ? IconCheckmarkCircled : IconCircle;

  return (
    <div className={cn(s.checkPoint, { [s.completed]: isChecked })}>
      <Component className={isChecked ? s.filledCheckIcon : s.circleIcon} width={20} height={20} />
      {children}
    </div>
  );
};

export { CheckPoint };
